import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { store } from '@/store';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
// @ts-ignore
import vuetify from './plugins/vuetify';
import VuetifyDialog from 'vuetify-dialog';
import 'vuetify-dialog/dist/vuetify-dialog.css';
require('vue-tour/dist/vue-tour.css');
// @ts-ignore
import VueTour from 'vue-tour';

Vue.use(VueTour);

import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

Vue.use(VuetifyDialog, {
    context: {
        vuetify,
    },
});

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    // @ts-ignore
    vuetify,
    render: (h) => h(App),
}).$mount('#app');
